import React, { useEffect, useRef } from 'react';

import { IPressPostFields } from '../../../types/contentful';

import { ColorTokenProp } from '../../theme/tokens/color';

import { Text } from '../Text';
import { Box } from '../Box';

import { InlineAnchor } from '../RichText/styles';
import { Logo, LogoWrapper } from './styles';

interface Props extends IPressPostFields {
  color: ColorTokenProp;
  focused?: boolean;
}

export function PressPost({
  title,
  preview,
  featured,
  sourceName,
  logo,
  color,
  linkToSource,
  focused = false
}: Props) {
  const linkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (focused) linkRef.current?.focus();
  }, [focused]);

  const { file, description } = logo?.fields ?? {};

  return (
    <Box
      backgroundColor="pressPostBg"
      borderRadius={{
        0: ['pressPostHeader', 'pressPostHeader', 'pressPost', 'pressPost']
      }}
      marginTop={{ desktop: 'xs' }}
    >
      <Box
        backgroundColor={color}
        borderRadius="pressPostHeader"
        padding={{ 0: 'm' }}
        marginTop={{ desktop: 'xs' }}
      >
        {file && featured ? (
          <LogoWrapper>
            <Logo
              src={file?.url ?? undefined}
              alt={description ?? 'logo'}
              loading="lazy"
            />
          </LogoWrapper>
        ) : (
          <Text
            fontWeight="h3"
            fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
            lineHeight={{ 0: '2xl' }}
            colour="white"
            textAlign="center"
          >
            {sourceName}
          </Text>
        )}
      </Box>
      <Box
        padding={{ 0: ['l', 'l', 'xl', 'l'], tablet: ['l', 'xl', 'xl', 'xl'] }}
      >
        <Box paddingBottom="sm">
          <Text
            as="h3"
            fontWeight="h3"
            fontSize={{ 0: 'h3_0', tablet: 'h3_tablet' }}
          >
            {title}
          </Text>
        </Box>
        {preview && (
          <Box paddingBottom="sm">
            <Text as="p" fontSize={{ 0: 'p_0', tablet: 'p_desktop' }}>
              {preview}
            </Text>
          </Box>
        )}
        {linkToSource && (
          <InlineAnchor href={linkToSource} target="_blank" ref={linkRef}>
            Read more
          </InlineAnchor>
        )}
      </Box>
    </Box>
  );
}
